import React, { useState } from "react";
import Rating from "../Rating";
import { reviews } from "../../utils/reviews";

export default function Testimonial() {
  const [activeTab, setActiveTab] = useState(2);

  const handleTabClick = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  return (
    <div className="cs_tabs cs_style1">
      <div className="h-[10rem] flex items-center md:block md:h-[70dvh] md:overflow-y-auto md:overflow-x-hidden scrollbar-hide md:w-full w-[390px] overflow-x-auto">
        <ul className="cs_tab_links flex md:block">
          {reviews.map((review) => (
            <li
              key={review.id}
              className={`${activeTab === review.id ? "active" : ""} md:w-[96%]`}
            >
              <div
                className="cs_tab_link_in"
                onClick={() => handleTabClick(review.id)}
              >
                <div className="cs_testimonial_1_avatar w-[260px] md:w-full flex items-center gap-4">
                  <img
                    src={review.imgUrl}
                    alt="Avatar"
                    className="w-20 h-20 md:w-34 md:h-34 rounded-full object-cover"
                  />
                  <div className="cs_testimonial_1_avatar_right">
                    <h3 className="md:text-[24px] cs_semibold mb-0 uppercase text-sm">
                      {review.name}
                    </h3>
                    <p className="cs_heading_color mb-0 text-[12px] md:text-[16px]">
                      {review.location}
                    </p>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="cs_tab_body">
        {reviews.map(
          (review) =>
            activeTab === review.id && (
              <div key={review.id} className="cs_testimonial cs_style_1">
                <img src="/images/icons/quote.svg" alt="Icon" />
                <p className="capitalize font-medium text-lg">{review.name}</p>
                <p className="text-justify">{review.review}</p>
                <Rating ratingNumber={review.rating} />
              </div>
            )
        )}
      </div>
    </div>
  );
}
